<template>
    <button :type="type" :class="`size_${size}    color_${color}`" class="default_button">
        <slot />
    </button>
</template>

<script setup>
defineProps({
    size: {
        type: String,
        default: 'medium',
    },
    type: {
        type: String,
        default: undefined,
    },
    color: {
        type: String,
        default: 'primary',
    },
});
</script>

<style scoped>
.default_button {
    border-radius: 3px;
    border: none;
    transition: 0.2s;
}

.default_button:disabled {
    color: #aaaaaa;
    background: #dbdbdb;
}

.default_button:hover:disabled {
    color: #aaaaaa;
    background: #dbdbdb;
    box-shadow: none;
}

.size_small {
    padding: 12px 8px;
}

.size_medium {
    padding: 10px 28px;
    font-size: 14px;
}

.size_large {
    padding: 16px 28px;
    font-size: 16px;
}

.color_primary {
    background: #e4003c;
    color: #ffffff;
}

.color_primary:hover {
    background: #ff465c;
    box-shadow: 0px 2px 12px rgba(198, 7, 57, 0.25);
}

.color_secondary {
    background: #48538b;
    color: #ffffff;
}

.color_secondary:hover {
    background: #848fc9;
    box-shadow: 0px 2px 12px rgba(33, 29, 86, 0.25);
}

.color_grey {
    background: #f6f6f6;
    color: #2b2b2b;
    font-weight: 700;
}

.color_grey:hover {
    background: #48538b;
    color: white;
    box-shadow: 0px 2px 12px rgba(33, 29, 86, 0.25);
}
</style>
